module.exports = __webpack_public_path__ + "static/media/13.497d3c67.png";